import {
  IPagination,
  IPaginationInfo,
  IPaginationMeta,
  IPaginationState,
} from "./types";
import { observable, runInAction } from "mobx";

export const initialPaginationMeta: IPaginationMeta = {
  current_page: 0,
  last_page: 1,
  per_page: 10,
  total: 10,
};

export const initialPaginationState: IPaginationState = {
  current_page: 0,
  infinitive: false,
  per_page: 10,
};

export class Pagination<T> implements IPagination<T> {
  private pagination: IPaginationInfo<T>;

  public constructor(initial: Partial<IPaginationInfo<T>> | undefined) {
    this.pagination = observable({
      data: initial?.data ?? ([] as T[]),
      meta: initial?.meta ?? initialPaginationMeta,
      state: initial?.state ?? initialPaginationState,
    });
  }

  public get meta(): IPaginationMeta {
    return this.pagination.meta;
  }

  public get state(): IPaginationState {
    return this.pagination.state;
  }

  public get data(): T[] {
    return this.pagination.data;
  }

  public set state(state: Partial<IPaginationState>) {
    if (state.current_page)
      this.pagination.state.current_page = state.current_page;

    if (state.per_page) this.pagination.state.per_page = state.per_page;
  }

  public set metadata({ meta, data, state }: Partial<IPaginationInfo<T>>) {
    const metadata = this.cast(meta, data, state);

    runInAction(() => {
      this.pagination.data = metadata.data;
      this.pagination.meta = metadata.meta;
      this.pagination.state = metadata.state;
    });
  }

  private cast = (
    _meta: IPaginationMeta | undefined,
    _data: T[] | undefined,
    _state: IPaginationState | undefined
  ): IPaginationInfo<T> => ({
    data: Array.isArray(_data) ? _data : [],
    meta: {
      current_page: _meta?.current_page ?? initialPaginationMeta.current_page,
      // from: _meta?.from || initialMeta.from,
      last_page: _meta?.last_page ?? initialPaginationMeta.last_page,
      // path: _meta?.path || initialMeta.path,
      per_page: _meta?.per_page ?? initialPaginationMeta.per_page,
      // to: _meta?.to || initialMeta.to,
      total: _meta?.total ?? initialPaginationMeta.total,
    },
    state: {
      current_page: _state?.current_page ?? initialPaginationState.current_page,
      infinitive: _state?.infinitive ?? initialPaginationState.infinitive,
      per_page: _state?.per_page ?? initialPaginationState.per_page,
    },
  });
}
